import { observer } from "mobx-react-lite";

import { DecoratorNode } from "@/components/expression/DecoratorNode";
import { twMerge } from "@/utils/twMerge";

import type { DecoratorNodeModel } from "@/models/nodes/DecoratorNodeModel";
import type { PropsWithChildren } from "react";

type Props = {
  decorators?: DecoratorNodeModel[];
  className?: string;
  wrapperClassName?: string;
  isSelected?: boolean;
};

export const Decorators = observer(function Decorators({
  decorators = [],
  className,
  wrapperClassName,
  isSelected,
  children,
}: PropsWithChildren<Props>) {
  if (decorators.length === 0) {
    return children;
  }

  return (
    <div
      className={twMerge(
        "relative flex flex-row items-center",
        "before:content-zero-space",
        className,
      )}
    >
      <div
        className={twMerge("pointer-events-none absolute left-0 top-0 right-0", wrapperClassName)}
      >
        {decorators.map((decorator) => (
          <DecoratorNode key={decorator.id} node={decorator} isSelected={isSelected} />
        ))}
      </div>
      {children}
    </div>
  );
});
